import type {
  OrganizationsTableColumn,
  OrganizationsTableProps,
} from "./organizations-list-table.type";

import { useTranslation } from "react-i18next";

import ListTable from "@/modules/list-table";
import { TABLE_FILTER_TEXT } from "@/modules/table-filter";

import { OrganizationsListTableRowActions } from "./organizations-list-table-row-actions";

export const OrganizationsListTable = ({
  ...listTableProps
}: OrganizationsTableProps) => {
  const { t } = useTranslation();

  const columns: OrganizationsTableColumn[] = [
    {
      width: "70%",
      title: t("global:name"),
      dataIndex: "name",
      sorter: true,
      ...TABLE_FILTER_TEXT,
    },
    {
      width: "10%",
      title: t("global:id"),
      dataIndex: "id",
      sorter: true,
      ...TABLE_FILTER_TEXT,
    },
    {
      width: "10%",
      title: t("global:locationPlural"),
      dataIndex: "locations_count",
      sorter: true,
    },
    {
      width: "10%",
      title: t("global:assetPlural"),
      dataIndex: "assets_count",
      sorter: true,
    },
    {
      title: "",
      fixed: "right",
      render: (_, organization) => (
        <OrganizationsListTableRowActions organization={organization} />
      ),
    },
  ];

  return (
    <ListTable modelKey="organization" columns={columns} {...listTableProps} />
  );
};
